import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAvatarArrowDown = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 14,
	height: 14,
	viewBox: "0 0 14 14",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("rect", {
			x: .5,
			y: .5,
			width: 13,
			height: 13,
			rx: 6.5,
			fill: "#E1E1E5"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: .5,
			y: .5,
			width: 13,
			height: 13,
			rx: 6.5,
			stroke: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M6.99939 7.68324L9.88677 4.7959L10.7117 5.62085L6.99939 9.33319L3.28711 5.62085L4.11207 4.7959L6.99939 7.68324Z",
			fill: "#4A4D53"
		})
	]
});
const ForwardRef = forwardRef(SvgAvatarArrowDown);
export { ForwardRef as ReactComponent };
